'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-weight: 700;\n  text-transform: uppercase;\n  margin-left: 5px;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 3px 0px;\n  opacity: ', ';\n  pointer-events: ', ';\n\n  &:hover {\n    text-decoration: underline;\n  }\n'], ['\n  font-weight: 700;\n  text-transform: uppercase;\n  margin-left: 5px;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 3px 0px;\n  opacity: ', ';\n  pointer-events: ', ';\n\n  &:hover {\n    text-decoration: underline;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Undo = _styledComponents2.default.div(_templateObject, function (_ref) {
  var invisible = _ref.invisible;
  return invisible ? 0 : 1;
}, function (_ref2) {
  var invisible = _ref2.invisible;
  return invisible ? 'none' : 'auto';
});

exports.default = Undo;